//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import rulePlaceholder from './mixins/rulePlaceholder'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  data() {
    return {
      currentValue: '',
      rule: {
        custom: {
          currentValue: {
            required: () => '请输入内容',
          },
        },
      },
    }
  },
  mixins: [rulePlaceholder, downloadImgs],
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    console.log(this.question)
  },
  mounted() {
    this.$validator.localize('zh_CN', this.rule)
    if (this.question.v_answer) {
      this.currentValue = this.question.v_answer.content
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
  },
  watch: {
    currentValue(n) {
      const param = {
        index: this.index,
        v_answered: !!n,
      }
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)

      const v_answer = this.getValue()
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
    },
  },
  methods: {
    onBlur() {
      iosInput()
    },
    getValidateRule(item) {
      var rules = []
      if (item.required) {
        rules.push('required')
      }
      if (item.minLength && item.rule !== 'number') {
        rules.push(`min:${item.minLength}`)
        this.rule.custom.currentValue.min = () =>
          `至少输入${item.minLength}字符`
      }
      let maxLength = item.maxLength || 500
      if (
        maxLength &&
        this.currentValue.length > maxLength &&
        item.rule !== 'number'
      ) {
        rules.push('max')
        rules.push(`max:${maxLength},${this.currentValue.length}`)
      }

      if (item.rule !== 'ignore') {
        if (item.rule === 'number') {
          const min = !item.minLength && String(item.minLength) !== '0';
          const max = !item.maxLength && String(item.maxLength) !== '0';
          rules.push(`number`)
          rules.push(
            `between:${min ? -1000000000 : item.minLength},${max ? 1000000000 : item.maxLength}`
          )
        } else {
          rules.push(`${item.rule}`)
        }
      }
      console.log(rules, '-----------')
      return rules.join('|')
    },
    getValue() {
      return {
        tenantId: this.question.tenantId,
        type: 'blank',
        content: this.currentValue,
      }
    },
    validate() {
      return this.$validator.validate()
    },
  },
}
